<template>
  <Link
    v-bind="$attrs"
    :href="route('coupons.index')"
    class="click-me relative group duration-300"
  >
    <div class="relative flex p-8 pb-0 lg:p-16 z-10">
      <div class="max-w-sm">
        <h2 class="text-3xl font-bold mb-2" style="line-height: 1.1;">Abos 25/26 erhältlich!</h2>
        <p>Sparen Sie beim Kauf eines Abos und buchen Sie Tickets bereits zwei Wochen vor dem offiziellen Vorverkauf.</p>
      </div>
      <div class="flex flex-1 items-center pl-8">
        <Icon
          class="ml-auto transition duration-300 transform group-hover:translate-x-[33.3%]"
          type="arrow-right"
          size="10"
        />
      </div>
    </div>
    <div class="lg:absolute lg:right-10 lg:top-[50%] lg:translate-y-[-50%] z-0">
      <img class="max-w-full w-[36rem] mx-auto block" src="/media/Abo_Mockup.png" alt="Abos">
    </div>
  </Link>
</template>

<script>
import Icon from 'Web/Shared/Icon.vue';
import Link from 'Web/Shared/Link.vue';

export default {
  inheritAttrs: false,
  components: {
    Icon,
    Link,
  }
}
</script>
